<template>
  <router-view v-if="inited"></router-view>
</template>

<script>
    import { functions } from './functions.js';
    import { Event } from 'vue-tables-2'
    import Vue from 'vue';
//    import VueNativeSock from 'vue-native-websocket'
//    //Vue.use(VueNativeSock, 'wss://echo.websocket.org');
//    Vue.use(VueNativeSock, 'ws://zt.nsb.su:8088', {
//        reconnection: true, // (Boolean) whether to reconnect automatically (false)
//        reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
//        reconnectionDelay: 1000, // (Number) how long to initially wait before attempting a new (1000)
//    });


    export default {
        name: 'app',
        data: function () {
            return {
                nav:null,
                timer:null,
                conn:null,
            }
        },
        mixins: [functions],
        methods: {
            doAuth: function (credentials) {
                localStorage.removeItem('authtoken');
                let self = this;
                this.$http.put(this.$store.state.apiloginurl , {cmd:'login', credentials:credentials}).then(function (response) {
                    let body = response.body;
                    if (typeof body === 'string') {
                        body = JSON.parse(body);
                    }
                    let authtoken = body.payload.authtoken;
                    localStorage.authtoken = authtoken;
                    self.$store.commit('setAuthToken', authtoken);
                    self.$store.commit('setAuthUser', body.payload.user);
                    this.$router.push({ name: 'Home', params: {  } })
                    this.updateStatus();
                }, function (error) {
                    this.error_log('авторизоваться не удалось');
                    this.error_log(error);
                    this.doLogout();
                });
            },
            doAuthAs:function (id) {

                let self = this;
                let token = self.$store.state.authtoken;
                this.$http.put(this.apiurl('auth/loginas'), { id:id})
                    .then(function (response) {
                        localStorage.removeItem('authtoken');
                        let body = response.body;
                        if (typeof body === 'string') {
                            body = JSON.parse(body);
                        }
                        let authtoken = body.payload.authtoken;
                        localStorage.authtoken = authtoken;
                        self.$store.commit('setAuthToken', authtoken);
                        self.$store.commit('setAuthUser', body.payload.user);
                        this.$router.push({ name: 'Home', params: {  } })
                        this.updateStatus();
                    }, function (error) {
                        console.log('получить пользователя не удалось');
                        this.error_log(error);
                        this.doLogout();
                    });
            },
            doStayLogined:function () {
                alert('doStayLogined')
                let self = this;
                let token = self.$store.state.authtoken;
                this.$http.put(this.apiurl('auth/stay'))
                    .then(function (response) {
                        console.log('stay...')
                    }, function (error) {
                        console.log('получить пользователя не удалось');
                        this.error_log(error);
                    });
            },
            doLogout: function () {
                localStorage.removeItem('authtoken');
                localStorage.authtoken = '';
                this.$store.commit('resetAuthToken');
                this.$store.commit('setNavMode', 'guest');
                this.$store.commit('resetUser');
                this.$router.push({ name: 'Login', params: {  } })
            },
            loadUser: function () {
                let self = this;
                this.$http.get(this.apiurl('user/me')).then(response => response.body)
                    .then(function (json) {
                      self.$store.commit('setAuthUser', json.payload);
                  }, function (error) {
                      console.log('получить пользователя не удалось');
                      this.error_log(error);
                      this.doLogout();
                  });
            },
            updateStatus: function () {
                let self = this;
                if (is(this.$store.state.authtoken)) {
                    this.$http.get(this.apiurl('status'))
                    .then(response => response.body)
                    .then(function (json) {
                        this.$store.commit('setStatus', json.payload);
                        setTimeout(function(){ self.updateStatus() }, 120000);
                    }, function (error) {
                        this.error_log('получить стaтус не удалось');
                        this.error_log(error);
                        setTimeout(function(){ self.updateStatus() }, 120000);
                    });
                }
                else {
                    console.log('не авторизован')
                    setTimeout(function(){ self.updateStatus() }, 120000);
                }

            },
            socketTest: function () {
                let self = this;
                console.log('socketTest');
                setTimeout(function(){ self.socketTest() }, 3000);

                if (this.conn && this.conn!==null)
                  this.conn.send('Hello World!' + navigator.userAgent);

                console.log('socketTest OK');
            },

            updateCurrentTime: function () {
                this.$store.commit('setCurrentTime');
                let self = this;
                setTimeout(function(){ self.updateCurrentTime() }, 1000);
            },
            doReloadUser: function () {
                console.log('doReloadUser');
                this.loadUser();
            }
        },


        mounted:function () {
            if (localStorage.authtoken) {
                this.authtoken = localStorage.authtoken;
                //this.$store.commit('loadUserByToken', this.authtoken);
            }
            else {
                this.$router.push({ name: 'Login', params: {  } })
            }

            this.updateStatus();
            //this.socketTest();
            //this.$options.sockets.onmessage = (data) => console.log(data)
        },
        created: function() {
            //this.$store.commit('setBaseUrl', {apibaseurl:'http://forms.nsb.loc/api/', apiloginurl:'http://zt.nsb.loc/api/auth/login/'});

            if ((typeof localStorage.authtoken!=='undefined') && (localStorage.authtoken!=='undefined') &&  localStorage.authtoken) {
                this.$store.commit('setAuthToken', localStorage.authtoken);
                this.loadUser();
            }
            this.$eventHub.$on('logout', this.doLogout);
            this.$eventHub.$on('login', this.doAuth);
            this.$eventHub.$on('loginas', this.doAuthAs);
            Event.$on('vue-tables.loading', ()=>{ this.$eventHub.$emit('loading_start'); });
            Event.$on('vue-tables.loaded',()=>{ this.$eventHub.$emit('loading_end');  });

            // window.onpopstate = function(event) {
            //     alert("2 location: " + document.location + ", state: " + JSON.stringify(event.state));
            // };

//            //this.conn = new WebSocket('ws://echo.websocket.org');
//            //this.conn = new WebSocket('ws://localhost:8088');
//            this.conn = new WebSocket('ws://zt.nsb.su:8088');
//            this.conn.onopen = function(e) {
//                console.log("Connection established!");
//            };
//
//            this.conn.onmessage = function(e) {
//                console.log(e.data);
//            };
            this.updateCurrentTime();
        },
        beforeDestroy: function () {
            //alert('beforeDestroy');
            this.$eventHub.$off('logout');
            this.$eventHub.$off('login');
        },



//        socket: {
//            // Prefix for event names
//            // prefix: "/counter/",
//
//            // If you set `namespace`, it will create a new socket connection to the namespace instead of `/`
//            // namespace: "/counter",
//
//            events: {
//
//                // Similar as this.$socket.on("changed", (msg) => { ... });
//                // If you set `prefix` to `/counter/`, the event name will be `/counter/changed`
//                //
//                changed(msg) {
//                    console.log("Something changed: " + msg);
//                },
//
//                connect() {
//                    console.log("Websocket connected to " + this.$socket.nsp);
//                },
//
//                disconnect() {
//                    console.log("Websocket disconnected from " + this.$socket.nsp);
//                },
//
//                error(err) {
//                    console.error("Websocket error!", err);
//                }
//
//            }
//        }
    }
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '~@coreui/icons/css/coreui-icons.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
  /* Import Flag Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
